import { CheckSmall } from "@components/Icons"
import { Box } from "@components/Layout"
import React from "react"
import { GridColumnProps, GridRowProps } from "styled-system"
import { FeedbackType } from "../"
import * as S from "../elements"
import { CheckboxStyle } from "./elements"

interface Props
  extends GridColumnProps,
    GridRowProps,
    React.InputHTMLAttributes<HTMLInputElement> {
  feedbackType?: FeedbackType
  errorMsg?: string
}

export const Checkbox: React.FC<Props> = ({
  children,
  gridColumn,
  gridRow,
  checked = false,
  id,
  name,
  ...rest
}) => {
  return (
    <Box gridColumn={gridColumn} gridRow={gridRow} overflow="visible">
      <CheckboxStyle {...rest}>
        <input checked={checked} readOnly type="checkbox" id={id} name={name} />
        <span>
          <CheckSmall />
        </span>
        {children && <label htmlFor={id}>{children}</label>}
      </CheckboxStyle>
      {rest.errorMsg && <S.Error>{rest.errorMsg}</S.Error>}
    </Box>
  )
}
